import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = [ "datepicker", "day", "list", "info", "date", "form", "wrapper"]
  static values = { 
    url: String,
    callback: String
  }

  connect() {
    this.initDatepicker()
  }

  toggleForm(event) {
    const visible = event.target.checked
    this.formTarget.classList.toggle('d-none', !visible)
    this.wrapperTarget.classList.toggle('d-none', !visible)
  }

  initDatepicker() {
    if (!this.hasDatepickerTarget) return

    $(this.datepickerTarget).datepicker({
      format: 'dd/mm/yyyy',
      autoclose: true,
      todayHighlight: true,
      language: 'it',
      daysOfWeekHighlighted: "0,6",
      weekStart: 1
    }).on('changeDate', this.handleDateChange.bind(this))
  }

  handleDateChange(event) {
    const date = event.format()
    const url = this.urlValue + `?start=${date}&end=${date}`
    
    this.dayTarget.value = date
    this.dateTarget.textContent = date
    
    this.fetchAppointments(url)
  }
  
  async fetchAppointments(url) {
    try {
      const response = await Turbo.fetch(url, {
        accept: 'application/json'
      })
      const data = await response.json()
      const appointments = data.map(this.appointmentTemplate)
      
      this.listTarget.innerHTML = appointments.join('')
      
      if (appointments.length === 0) {
        this.infoTarget.classList.remove('d-none')
      } else {
        this.infoTarget.classList.add('d-none')
      }
    } catch (error) {
      console.error("Error fetching appointments:", error)
    }
  }
  
  appointmentTemplate(appointment) {
    // You'll need to implement this based on your original appointmentTemplate function
    // This is just a placeholder
    return `<div class="border-bottom p-2 ${appointment.class}">
      <div class="d-flex justify-content-between">
        <div class="align-items-center">
          <div class="text-muted">${appointment.start_at} - ${appointment.end_at}</div>
          <div>
            <i class="fa ${appointment.kind_icon} me-1"></i>
            <span>${appointment.description}</span>
          </div>
        </div>
        <div class="align-items-center d-flex ms-4">
          <span class="badge text-bg-primary">
            <i class="fa fa-user me-1"></i>
            ${appointment.user_name}
          </span>
        </div>
      </div>
    </div>`
  }
}